/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Both_Password_Fields_RequiredInputs */

const en_common_both_password_fields_required = /** @type {(inputs: Common_Both_Password_Fields_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Both password fields are required`)
};

const es_common_both_password_fields_required = /** @type {(inputs: Common_Both_Password_Fields_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ambos campos de contraseña son obligatorios`)
};

/**
* | output |
* | --- |
* | "Both password fields are required" |
*
* @param {Common_Both_Password_Fields_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_both_password_fields_required = /** @type {((inputs?: Common_Both_Password_Fields_RequiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Both_Password_Fields_RequiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_both_password_fields_required(inputs)
	return en_common_both_password_fields_required(inputs)
});